import React from 'react';
import {
    TRANSLATIONS_MEALS_LIMIT_REPLACEMENT,
    TRANSLATIONS_PICKED_PRODUCTS_COUNT_REPLACEMENT,
} from '../shared/constants';

export const PhaseStepBlock = (props) => {
    const {
        onPhaseStepBlockClick,
        mealsLimit,
        pickedProductsCount,
        phaseStepStatus,
        isDisabled,
        phaseStepName,
        translations,
        isActive,
        isFirst,
        isLast,
        productExceedAvailability,
    } = props;

    return (
        <button
            className={`
                phase-step-navigation phase-step-navigation--${phaseStepStatus}
                ${isDisabled ? ' phase-step-navigation--disabled' : ''}
                ${isActive ? ' phase-step-navigation--active' : ''}
                ${isFirst ? ' phase-step-navigation--first' : ''}
                ${isLast ? ' phase-step-navigation--last' : ''}
                ${productExceedAvailability ? ' phase-step-navigation--with-error' : ''}
            `}
            type="button"
            data-tip={translations['eshop.configurator.phase_step_not_completed']}
            data-tip-disable={!isDisabled}
            onClick={isDisabled ? undefined : onPhaseStepBlockClick}
        >
            <div className="phase-step-navigation__inner-wrapper">
                <div className="phase-step-navigation__checkbox"></div>
                <div className="phase-step-navigation__text-wrapper">
                    <div className="phase-step-navigation__title">{phaseStepName}</div>
                    <div className="phase-step-navigation__picked-meals">
                        {translations['eshop.configurator.message_part.selected']}:{' '}
                        {translations['eshop.configurator.message_part.product_of_meals']
                            .replace(TRANSLATIONS_PICKED_PRODUCTS_COUNT_REPLACEMENT, pickedProductsCount)
                            .replace(TRANSLATIONS_MEALS_LIMIT_REPLACEMENT, mealsLimit)}
                    </div>
                </div>
            </div>
        </button>
    );
};
